import { Notification } from "./Notification";
export class NotificationItem extends Notification {
   itemSvg: string;
   itemIconClass: string;
   itemSymbolClass: string;
}
